// src/PublicUser/components/tools/ToolCard.jsx
import React from 'react';

export default function ToolCard({ tool, isSaved, onToggleSave }) {
  return (
    <div className={`ts-tools-card ${tool.featured ? 'ts-featured' : ''}`}>
      <div>
        <div className="ts-tools-card-top">
          <div className="ts-tools-icon-box">{tool.icon}</div>
          <div className="ts-tools-info-block">
            <h3>{tool.name}</h3>
            <span className="ts-tools-tag">{tool.category}</span>
          </div>
          <button 
            className="ts-tools-action-star" 
            onClick={onToggleSave}
            style={{ color: isSaved ? '#eab308' : '#94a3b8' }}
          >
            {isSaved ? '★' : '☆'}
          </button>
        </div>
        <p className="ts-tools-desc">{tool.description}</p>
      </div>

      <div className="ts-tools-card-bottom">
        <span className={`ts-tools-badge ${tool.pricing.toLowerCase()}`}>
          {tool.pricing}
        </span>
        <a href={tool.url} target="_blank" rel="noopener noreferrer" className="ts-tools-link">
          Open ↗
        </a>
      </div>
    </div>
  );
}